import React from "react";
import { useLang } from "@/context/LangContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="relative bg-[#1A1C1A] text-[#FDFBF7] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <div className="md:col-span-5">
            <p className="text-xs tracking-[0.25em] text-white/50 mb-3">DAWNVILLE — ENGLISH STUDIO</p>
            <p className="text-base text-white/80 max-w-md">English, taught with the precision of a literary editor and the warmth of a good morning conversation.</p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.25em] text-white/50 mb-3">{t.contact.address_label}</p>
            <p className="text-sm text-white/80">{t.contact.address}</p>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.25em] text-white/50 mb-3">{t.contact.wechat_label} <span className="text-[hsl(var(--primary))]">· {t.contact.recommended}</span></p>
            <p className="text-sm text-white/80">{t.contact.wechat}</p>
            <p className="text-xs tracking-[0.25em] text-white/50 mt-5 mb-3">{t.contact.line_label}</p>
            <p className="text-sm text-white/80">{t.contact.line}</p>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.25em] text-white/50 mb-3">{t.contact.email_label}</p>
            <p className="text-sm text-white/80 break-all">{t.contact.email}</p>
            <p className="text-xs tracking-[0.25em] text-white/50 mt-5 mb-3">{t.contact.hours_label}</p>
            <p className="text-sm text-white/80">{t.contact.hours}</p>
          </div>
        </div>

        <div className="ascii-rule mb-8" />
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="font-display font-medium leading-[0.85] tracking-tighter text-white text-[18vw] md:text-[14vw]">
            Dawnville
          </div>
        </div>
        <div className="mt-10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Dawnville English Studio. All rights reserved.</p>
          <p>Made with care · Built for thinking students.</p>
        </div>
      </div>
    </footer>
  );
}
